export default "__VITE_ASSET__BwmOg5qK__"